import { useMemo } from "react";
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import { useAutocompleteOptions } from "../../../../hooks/autocomplete/useAutocompleteOptions";
import { assetSizes } from "../../../constants/securspace-constants";

interface AssetSizeAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
}

const AssetSizeAutocomplete = (props: AssetSizeAutocompleteProps) => {

  const assetSizeOptions = useMemo(() => assetSizes.map(size => ({id: size, label: `${size}'`})), [])
  
  const renderInput = (params: any) => (
    <TextField {...params} label={'Asset Size'} variant={'standard'} />
  )

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
  } = useAutocompleteOptions({ autocompleteOptions: assetSizeOptions })

  return <Autocomplete
      disablePortal
      disableClearable
      renderInput={renderInput}
      options={assetSizeOptions}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      {...props}
    />
}

export { AssetSizeAutocomplete };
